import styled from 'styled-components';

export const ProfileItemsWrapper = styled.div`
    margin-left: 26px;
`;
